export var invalidProvider = function invalidProvider(message) {
  return function () {
    return Promise.reject(message);
  };
};